import { render, staticRenderFns } from "./RoleGrantButton.vue?vue&type=template&id=af02806a&scoped=true&"
import script from "./RoleGrantButton.vue?vue&type=script&lang=js&"
export * from "./RoleGrantButton.vue?vue&type=script&lang=js&"
import style0 from "./RoleGrantButton.vue?vue&type=style&index=0&id=af02806a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af02806a",
  null
  
)

export default component.exports